"use strict";

var _interopRequireDefault = require("D:/git\u4ED3\u5E93/xingxingzu/multi_merchant_web/supplier/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regeneratorRuntime2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/xingxingzu/multi_merchant_web/supplier/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/xingxingzu/multi_merchant_web/supplier/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _encrypted = require("@/api/encrypted");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  props: ['formList', 'platformId'],
  data: function data() {
    return {
      form: {
        platformWhiteList: [],
        platformBlackList: []
      },
      rules: {
        platformWhiteList: [{
          required: true,
          message: '请选择白名单',
          trigger: 'change'
        }],
        platformBlackList: [{
          required: true,
          message: '请选择黑名单',
          trigger: 'change'
        }]
      },
      dialogVisible: false,
      platformStatisList: []
    };
  },
  mounted: function mounted() {
    this.getPlatformList();
  },
  unmounted: function unmounted() {
    this.resetParams();
  },
  methods: {
    submit: function submit() {
      var _this = this;
      this.$refs['ruleForm'].validate(function (valid) {
        if (valid) {
          console.log('this.form', _this.form, 'pid', _this.platformId);
          var params = {
            platform_id: _this.platformId,
            include_platform: _this.form.platformWhiteList,
            exclude_platform: _this.form.platformBlackList
          };
          console.log('params', params);
          // return
          // 更新他的include或者exclude字段
          (0, _encrypted.updatePlatformAPI)(params).then(function (res) {
            _this.dialogVisible = false;
            _this.$emit('getList', true);
          });
        } else {
          _this.$message({
            message: '请检查表单错误',
            type: 'error'
          });
          return false;
        }
      });
    },
    resetParams: function resetParams() {
      this.form.platformWhiteList = [];
      this.form.platformBlackList = [];
    },
    getPlatformList: function () {
      var _getPlatformList = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var _this2 = this;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.form.platformWhiteList = this.formList.include || [];
                this.form.platformBlackList = this.formList.exclude || [];
                console.log('this.form', this.form);
                (0, _encrypted.getPlatformListAPI)({}).then(function (res) {
                  console.log('获取平台列表原始数据', res);
                  var statisNameList = res.map(function (item) {
                    return {
                      value: item.statis_table_name,
                      label: item.remark,
                      key: item.platform_id
                    };
                  }).filter(function (name) {
                    return name;
                  });
                  _this2.platformStatisList = statisNameList;
                  console.log('platformStatisList', _this2.platformStatisList);
                });
              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
      function getPlatformList() {
        return _getPlatformList.apply(this, arguments);
      }
      return getPlatformList;
    }()
  }
};
exports.default = _default;